import { createSlice } from '@reduxjs/toolkit'

import { addExtraReducer } from '../../../store/addExtraReducer'

import initialState from './initialState'
import {
  GetNewsReducer,
  GetDailyAnalysisReducer,
  GetLast7DaysAnalysisReducer,
  GetSymbolsReducer,
} from './reducers'
import { GetNews, GetDailyAnalysis, GetLast7DaysAnalysis, GetSymbols } from './thunks'

const AIMarketInsightsSlice = createSlice({
  name: 'aiMarketInsights',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    addExtraReducer(builder, GetNews, GetNewsReducer)
    addExtraReducer(builder, GetSymbols, GetSymbolsReducer)
    addExtraReducer(builder, GetDailyAnalysis, GetDailyAnalysisReducer)
    addExtraReducer(builder, GetLast7DaysAnalysis, GetLast7DaysAnalysisReducer)
  },
})

const AIMarketInsightsReducer = AIMarketInsightsSlice.reducer
export default AIMarketInsightsReducer
